<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';

@Component
export default class SpinnerComponent extends Vue {
    @Prop()
    public label: string | undefined;

    @Prop({ default: 'spinner-component' })
    public dataID!: string;
}
</script>

<template>
    <div class="m-spinnerComponent" :data-js="dataID">
        <div class="a-spinner">
            <div class="a-spinner__element primary-element"></div>
            <div class="a-spinner__element secondary-element"></div>
        </div>

        <p class="m-spinnerComponent__label" v-if="label">{{ label }}</p>
    </div>
</template>
